import React, { forwardRef, ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';
import { Box } from '@mui/material';

export interface PageProps {
  children: ReactNode;
  title?: string;
  [key: string]: unknown;
}

const Page = forwardRef<HTMLDivElement, PageProps>(
  ({ children, title = '', ...other }, ref) => {
    return (
      <Box ref={ref} {...other}>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        {children}
      </Box>
    );
  }
);

Page.displayName = 'Page';

export default Page;
